import { MutationTree } from 'vuex'
import { UserStateInterface } from 'src/store/user/state'
import { User } from 'able-lib'

const mutation: MutationTree<UserStateInterface> = {
  SET_USER (state: UserStateInterface, user: User): void {
    state.user = user
  },
  SET_USERS (state: UserStateInterface, users: Array<User>): void {
    state.users = users
  },
  SET_ROLES (state: UserStateInterface, list: Array<any>): void {
    state.roles = list
  },
  SET_LOCATIONS (state: UserStateInterface, list: Array<any>): void {
    state.locations = list
  }
}

export default mutation
